import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Remet la fenêtre en haut à chaque changement de page (évite d'arriver au milieu)
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}
